const base = '/api/users';

async function request(path = '', options = {}) {
  const res = await fetch(base + path, { headers: { 'Content-Type': 'application/json' }, ...options });
  if (!res.ok) {
    const text = await res.text();
    let msg = `Request failed: ${res.status}`;
    try { const json = JSON.parse(text); if (json && json.message) msg = json.message; } catch (e) {}
    throw new Error(msg);
  }
  if (res.status === 204) return null;
  return res.json();
}

export async function listUsers() {
  return request('');
}

export async function createUser(payload) {
  return request('', { method: 'POST', body: JSON.stringify(payload) });
}

export async function updateUser(id, payload) {
  return request(`/${id}`, { method: 'PUT', body: JSON.stringify(payload) });
}

export async function deleteUser(id) {
  return request(`/${id}`, { method: 'DELETE' });
}

export default { listUsers, createUser, updateUser, deleteUser };
